import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Button } from "@mui/material";
import { ThemeProvider } from "@mui/material";
import theme from "../../../theme";
import DataTableComponent from "../../../components/Table/DataTableComponent";
import tableHeaders from "../../../data/tableHeader";
import {
  DeletePromoCode,
  GetPromoCodeList,
} from "../../../api/promo/PromoCodeController";
import DeleteDialogComponent from "../../../components/Dialog/DeleteDialogComponent";
const PromoCodePage = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showIdColumns, setShowIdColumns] = useState(false);
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [page, setPage] = useState(0); // 0-based index
  const [showDetailModal, setShowDetailModal] = useState(false); // New state for modal visibility
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleMoreClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleViewDetails = () => {
    setShowDetailModal(true);
  };

  
  useEffect(() => {
    getPromoCodeList();
  }, []);

  const handleDelete = async () => {
    if (selectedRow) {
      console.log("Selected Row", selectedRow);
      const response = await DeletePromoCode(
        selectedRow.promotionCode,
        setLoading
      );
      console.log("Delete Response", response);
      if (response.baseResponseModel.respCode === 200) {
        getPromoCodeList();
      }
      handleClose();
    }
  };

  const handleOpenDeleteDialog = (selectedRow) => {
    setSelectedRow(selectedRow);
    setOpenDeleteDialog(true);
  };
  const onRefresh = async () => {
    await getPromoCodeList(setData, setLoading);
  };

  const getPromoCodeList = async () => {
    try {
      const response = await GetPromoCodeList(setLoading);
      console.log("Order Status:", response);
      setData(response.lstPromotion);
    } catch (err) {
      console.error("Error fetching order status:", err);
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} color="primary" />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <div style={{ marginBottom: "20px" }}>
          {/* Other category buttons can be added here if needed */}
        </div>
        <DataTableComponent
          data={data}
          showIdColumns={showIdColumns}
          handleMoreClick={handleMoreClick}
          anchorEl={anchorEl}
          handleClose={handleClose}
          handleViewDetails={handleViewDetails}
          tableHeaders={tableHeaders["PromoCode"]}
          isLoading={loading}
          setIsFilter={setIsFilterDrawerOpen}
          handleOpenDeleteDialog={handleOpenDeleteDialog}
          onRefresh={onRefresh}
          showNewAddButton={true}
          addBtnLabel={"Add New Promo Code"}
          requested={"PromoCode"}
        />
        <Button
          onClick={() => setShowIdColumns(!showIdColumns)}
          style={{ marginTop: "20px" }}
        >
          {showIdColumns ? "Hide ID Columns" : "Show ID Columns"}
        </Button>
      </div>
      <DeleteDialogComponent
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onDelete={handleDelete}
      />
    </ThemeProvider>
  );
};

export default PromoCodePage;
